module.exports = __webpack_public_path__ + "static/media/NSApp.6b46b9b8.gif";